// CountryDropdown.js
import React, { useState } from "react";
import "./countryDropdown.css";
import Image from "../Image";
import { ChevronDown } from "lucide-react";

const CountryDropdown = ({
  countries,
  selectedCountry,
  setSelectedCountry,
}) => {
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  const handleCountryChange = (country) => {
    setSelectedCountry(country);
    setIsDropdownVisible(false);
  };

  const toggleDropdown = () => {
    setIsDropdownVisible(!isDropdownVisible);
  };

  return (
    <div className="country-dropdown">
      <div
        className={`selected-country ${isDropdownVisible ? "active" : ""}`}
        onClick={toggleDropdown}
      >
        <Image
          className="flag-img"
          src={selectedCountry.flag}
          alt={selectedCountry.name}
        />
        <ChevronDown size={22} className="shrink-0 text-gray-400" />
      </div>
      {isDropdownVisible && (
        <div className={`country-list bg-white`} id="country-list">
          {countries.map((country) => (
            <>
              <div
                key={country.id}
                className="country-option"
                onClick={() => handleCountryChange(country)}
              >
                <Image src={country.flag} alt={country.name} />
              </div>
            </>
          ))}
        </div>
      )}
    </div>
  );
};

export default CountryDropdown;
